// RxJS
import { delay, distinctUntilChanged } from 'rxjs/operators';
// CRUD
import { QueryResultsModel, BaseDataSource } from '../../_base/crud';
// State
import { Store, select } from '@ngrx/store';
import { AppState } from '../../reducers';
// Selectors
import { selectMachinesInitWaitingMessage, selectMachinesInStore, selectMachinesPageLoading } from '../_selectors/machine.selectors';

export class MachinesDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
		super();
		this.loading$ = this.store.pipe(
			select(selectMachinesPageLoading)
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectMachinesInitWaitingMessage)
		);

		this.store.pipe(
			select(selectMachinesInStore)
		).subscribe((response: QueryResultsModel) => {
			this.paginatorTotalSubject.next(response.totalCount);
			this.entitySubject.next(response.items);
		});
	}
}
